import { Component, Input, OnInit } from '@angular/core';
import { SupportService } from 'src/app/services/core/support/support.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
import { OnboardingMenu, UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css'],
})
export class DriverComponent implements OnInit {

  driverModalObj:any;
  search:any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  filteredDriverList:any;
  @Input() companyId:any;
  status:boolean = true;
  userPermission=UserPermission
  loading = null;
  driverIndex:any;
  logObj:any;
  editDriverModalObj: any;
  selectedDropdownIndex:any;
  toggleActionButtons = false;
  private readonly searchSubject = new Subject<string | undefined>();

  constructor(
    private supportService: SupportService,
    private cedentialService : CredentialService,
    public permissionService: PermissionService,
    private sharedDataService: SharedDataService
  ){}

  drivers:any;

  ngOnInit(): void {
    this.getRedirectEntity();
    this.getCompanyWiseDrives(this.currentPage);
     this.initializeSearch();
  }

  getRedirectEntity() {
    this.sharedDataService
      .getOnboardingRedirectEntity()
      .pipe(untilDestroyed(this))
      .subscribe((redirect) => {
      if (redirect) {
        const {entity, entityType} = redirect;
        if (entity && entityType === OnboardingMenu.DRIVERS) {
          this.openDriverModal(entity);
          this.companyId = entity.company
          this.search = entity.email;
          this.status = entity.isActive;
          this.searchSubject.next(this.search);
          this.sharedDataService.setOnboardingRedirectEntity(null);
        }
      }
    });
  }


  getCompanyWiseDrives(page:number){
    let queryParams: any = {
      limit: 50,
      page,
      isActive : this.status
    }
     if (this.search) {
      queryParams.search = this.search.trim();;
    }
    this.cedentialService.getCompanyDrivers(this.companyId, queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data && data.results){
        this.drivers = data.results;
        this.drivers = data.results.sort((a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        this.filteredDriverList = [...this.drivers];
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    })
  }

  openDriverModal(driver:any){
    this.driverModalObj = driver;
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getCompanyWiseDrives(page);
  }

  onSelectStatus(): void {
   this.getCompanyWiseDrives(this.currentPage = 1);
  }

  raiseTicket(driver: any) {
    this.supportService.raiseTicket('driver', driver.id);
  }

  openLogModal(driver:any){
    this.logObj = driver.id;
  }

  onSyncData(id: any) {
    this.loading = id;
    this.cedentialService.onSyncData(id, 'drivers').subscribe({
      next: (data: any) => {
        sweetAlert('Success', 'Driver Synced Successfully!', 'success', 'OK');
        this.getCompanyWiseDrives(this.currentPage);
      },
      error: (err: any) => {
        console.error(err);
        sweetAlert('Error', err, 'error', 'OK');
      },
      complete: () => {
        this.loading = null;
      }

    })
  }

  onDriverStatusUpdated(updatedDriver: any) {
    if (!updatedDriver) {
      this.driverModalObj = null;
      return;
    }
    this.driverModalObj.isApproved = updatedDriver.isApproved;

  }

  openDriverEditModal(driver: any) {
    this.editDriverModalObj = driver;
  }

  onSaveDriver(evt: any) {
    if (evt) {
      const idx = this.filteredDriverList.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.filteredDriverList[idx] = evt;
      } else {
        this.filteredDriverList.splice(idx, 1);
      }
    }
    this.editDriverModalObj = null;
  }

   initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)
      ).subscribe(() => {
        console.log('driver: initializeSearch:')
        this.currentPage = 1;
        this.getCompanyWiseDrives(this.currentPage)
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  onCloseDriverModal() {
    this.editDriverModalObj = null;
  }

  showActionButtons(idx:any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  getLanguagesList(languages: any) {
    if (!languages) return [];
    return languages.split(/[\s,]+/).filter(Boolean).map((lang: string) => lang.trim());
  }

}
